import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { enableFreeMode } from 'bookingform';
import { logoutUser } from '../../actions/Session';
import { setHotel } from '../../actions/Booking';
import withNavigate from '../../withNavigate'; // Importa el HOC
import {
  setLoggedUser, setHasRegistered, setMemberInfo, setNewMember,
  setNewMemberDiscountPercentage, setCurrentStays, setCurrentNights, setCoinsApplied,
  setCoinsEntered, setMaxCoinsToApply, setOptinAccepted, setSaNetRatePercentage,
} from '../../actions/Loyalty';
import { deleteCookie } from '../../services/cookies';

import '../../static/less/user_login.less';

class UserLogin extends React.Component {
  constructor(props) {
    super(props);

    this.logoutUser = this.logoutUser.bind(this);
  }

  logoutUser() {
    this.props.dispatch(setHotel(null));
    this.props.dispatch(logoutUser()).then(() => {
      // Back to login before we attempt to render the current page (eg. rooms) in the incorrect state
      this.props.navigate('/callcenter/login/');
      this.props.dispatch(enableFreeMode(false));
      //También borramos los datos de sesión del usuario de loyalty para que no queden ahí
      deleteCookie('login-details');
      this.props.dispatch(setLoggedUser(null));
      this.props.dispatch(setHasRegistered(false));
      const memberInfo = {
        accountHolder: null, email: '', availableCoins: 0, cardCode: '',
      };
      this.props.dispatch(setMemberInfo(memberInfo));
      this.props.dispatch(setNewMember(false));
      this.props.dispatch(setNewMemberDiscountPercentage(0));
      this.props.dispatch(setSaNetRatePercentage(0));
      this.props.dispatch(setCurrentStays(0));
      this.props.dispatch(setCurrentNights(0));
      this.props.dispatch(setOptinAccepted(false));
      this.props.dispatch(setCoinsApplied(0));
      this.props.dispatch(setCoinsEntered(0));
      this.props.dispatch(setMaxCoinsToApply(0));
    });
  }

  render() {
    const { user } = this.props;
    if (user.isAnonymous) {
      return null;
    }
    return (
            <div className="UserLogin DropdownSelect">
              <div className="UserLogin__icon">
                <i className="fa fa-search" onClick={() => this.props.navigate('/my-booking/')}/>
              </div>
              <div className={`UserLogin__flag UserLogin__flag--${user.role}`}>
                <span>{this.roleName()}</span>
              </div>
              <div className="UserLogin__name" onClick={this.logoutUser}>
                {user.full_name}
                <i className="logout__button fa fa-sign-out"/>
              </div>
            </div>
    );
  }

  roleName() {
    // If we allow more role types, then check the role ID to return the appropriate name
    return this.context.t('Call Center');
  }
}

UserLogin.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

UserLogin.contextTypes = {
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

UserLogin.propTypes = {};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  user: state.session.user || { isAnonymous: true, role: '' },
});

const ConnectedUserLogin = connect(mapStateToProps)(UserLogin);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedUserLogin);
